import { Outlet, Link, useLocation } from 'react-router-dom';

export default function BroadcasterLayout() {
    const location = useLocation();

    const isActive = (path: string) => location.pathname.includes(path);

    return (
        <div className="flex h-screen bg-slate-950 text-white overflow-hidden font-sans">
            {/* Sidebar Navigation - Optimized for Touch */}
            <aside className="w-24 md:w-64 bg-slate-900 border-r border-slate-800 flex flex-col items-center md:items-stretch py-6 space-y-4">
                <div className="px-4 mb-4">
                    <h1 className="hidden md:block text-xl font-bold text-sky-500 tracking-tighter">CONTROL CENTER</h1>
                    <h1 className="md:hidden text-xl font-bold text-sky-500">CC</h1>
                </div>

                <nav className="flex-1 w-full space-y-2 px-2">
                    <Link to="/broadcaster"
                        className={`flex items-center p-4 rounded-xl transition-all active:scale-95 ${isActive('/broadcaster') && !isActive('/assets') ? 'bg-sky-600 text-white shadow-lg shadow-sky-900/50' : 'text-slate-400 hover:bg-slate-800'}`}>
                        <span className="text-2xl">🎮</span>
                        <span className="hidden md:block ml-3 font-semibold text-lg">Match Control</span>
                    </Link>

                    <Link to="/broadcaster/assets"
                        className={`flex items-center p-4 rounded-xl transition-all active:scale-95 ${isActive('/assets') ? 'bg-sky-600 text-white shadow-lg shadow-sky-900/50' : 'text-slate-400 hover:bg-slate-800'}`}>
                        <span className="text-2xl">🖼️</span>
                        <span className="hidden md:block ml-3 font-semibold text-lg">Assets</span>
                    </Link>

                    <Link to="/broadcaster/scouting"
                        className={`flex items-center p-4 rounded-xl transition-all active:scale-95 ${isActive('/scouting') ? 'bg-sky-600 text-white shadow-lg shadow-sky-900/50' : 'text-slate-400 hover:bg-slate-800'}`}>
                        <span className="text-2xl">📋</span>
                        <span className="hidden md:block ml-3 font-semibold text-lg">Scouting</span>
                    </Link>
                </nav>

                <div className="p-4 border-t border-slate-800">
                    <Link to="/" className="flex items-center justify-center p-4 bg-red-900/20 text-red-400 rounded-xl hover:bg-red-900/40 active:scale-95">
                        <span className="text-xl">🚪</span>
                        <span className="hidden md:block ml-2 font-bold">Exit</span>
                    </Link>
                </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1 relative overflow-hidden bg-slate-950">
                <Outlet />
            </main>
        </div>
    );
}
